import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findPlano from '../../service/findPlano';
import { Button } from 'primereact/button';
import { SortOrder } from 'primereact/api';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Nullable } from 'primereact/ts-helpers';
import { Toolbar } from 'primereact/toolbar';




export default function PlanoList({onEdit}:{onEdit:(plano:any)=>void}) {
  const { t } = useTranslation();
  const [planos, setPlanos] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const {state} = useGlobalState();
  const [descricao, setDescricao] = useState<Nullable<String | null>>(null);
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    descricao: descricao,
    idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    sortField: 'descricao',
    sortOrder: SortOrder.ASC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      descricao: descricao,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      descricao: descricao,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const changeDescricao = (desc:Nullable<String>) => {
    if(desc){
      setDescricao(desc);
      setlazyState({
        first: 0,
        rows: 10,
        page: 1,
        descricao: desc,
        idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'descricao',
        sortOrder: SortOrder.ASC
      });
    }
  }

  const startContent = (
      <React.Fragment>
        <div  style={{background:'transparent'}}>
          <div className="grid">
                
                <div className="col p-fluid flex flex-wrap">
                  <div >
                    <div className="flex-auto">
                        <label htmlFor="descricao" className="font-bold block mb-2">{t('descricao')} </label>
                        <InputText id="descricao" onBlur={(e)=>changeDescricao(e.target.value)} style={{width: '20rem'}}></InputText>
                    </div>
                  </div>
                </div>
         
              
            
          </div>
        </div>
      </React.Fragment>
    );

  const loadLazyData = () => {
    findPlano(lazyState).then(data => {setTotalRecords(data.total);setPlanos(data.planos)}).catch(() => {setTotalRecords(0);setPlanos(undefined)});
  }

  const editBodyTemplate = (plano:any) => {
    return <Button icon="pi pi-pencil" onClick={() => onEdit(plano)} style={{background:'transparent', color:'gray', border: 'none'}} />;
  };
  
  useEffect(() => {
    loadLazyData();
  },[lazyState])

  return (
    <div>
      <div>
        <Toolbar start={startContent} />
        <br></br>
        <br></br>
        <DataTable value={planos} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros"
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           
           <Column field="descricao" sortable header={t('descricao')}  />
           <Column body={editBodyTemplate} />
        </DataTable> 
      </div>
    </div>
  )
}


